const decodeHtmlString = (html: string) => {
	const txt = document.createElement('textarea')
	txt.innerHTML = html
	return txt.value
}

export default decodeHtmlString
